import { CoveragePath } from "../../CoveragePath/CoveragePath";
import { useConfiguration } from "../hooks/useConfiguration";

/** Reuses the existing coverage-path list. The shared draft lives in context. */
export function CoveragePathStep() {
  const {
    visiblePolicies,
    policyDraft,
    setPolicyDraft,
    pendingPaths,
    setPendingPaths,
    selectPolicy,
    policyWithEdits,
    createNewDraft,
    rememberPolicy,
    commitPolicyActive,
  } = useConfiguration();

  return (
    <CoveragePath
      policies={visiblePolicies}
      policyDraft={policyDraft}
      setPolicyDraft={setPolicyDraft}
      pendingPaths={pendingPaths}
      setPendingPaths={setPendingPaths}
      onSelectPolicy={selectPolicy}
      policyWithEdits={policyWithEdits}
      createNewDraft={createNewDraft}
      onRememberPolicy={rememberPolicy}
      onCommitActive={commitPolicyActive}
    />
  );
}
